import React from 'react';
import dayjs from 'dayjs';

//Estilos
import './GuiaPrint.css';
import logo from '../../assets/imgs/logo_inavi.png';
import { formatNumberLength } from '../../helpers';

function GuiaPrint({ functions, states, reference }) {
    const { formatNumber } = functions;

    const {
        masters,
        grapesVariety,
        GuiaData: { cabecera, itemsProductor, itemsBodega },
    } = states;

    return (
        <div className="guia_print-container">
            <div ref={reference} className="guia_print_parent">
                <header className="guia_print-header">
                    <img className="guia_print-logo" src={logo} alt="INAVI" />
                    <div className="guia_print-title">
                        <h2>
                            Guía &nbsp;
                            {cabecera?.serie}-
                            {
                                masters.LetterTypes?.find((lt) => lt.id === 4)
                                    .nombre
                            }
                            -{formatNumber(cabecera?.numero, 4)}
                        </h2>
                        <h3>(Ley Nº13.665 de 17-06-1968)</h3>
                    </div>
                </header>
                <section className="guia_print-info-section">
                    <table>
                        <tbody>
                            <tr>
                                <td>HABILITADA: </td>
                                <td>{cabecera?.estado ? 'SI' : 'NO'}</td>
                                <td>MATRÍCULA DEL VEHÍCULO: </td>
                                <td>{cabecera?.matricula_Vehiculo}</td>
                            </tr>
                            <tr>
                                <td>VIÑEDO: </td>
                                <td>{cabecera?.viniedo}</td>
                                <td>TITULAR DEL VIÑEDO: </td>
                                <td>{cabecera?.titular_Viniedo}</td>
                            </tr>
                            <tr>
                                <td>TIPO DE DOCUMENTO: </td>
                                <td>
                                    {
                                        masters.DocumentTypes?.find(
                                            (ht) =>
                                                ht.id === cabecera?.doc_id_tipo
                                        )?.nombre
                                    }
                                </td>
                                <td>DOCUMENTO: </td>
                                <td>{cabecera?.doc_id}</td>
                            </tr>
                            <tr>
                                <td>UBICACIÓN DEL VIÑEDO: </td>
                                <td>
                                    Latitud:{' '}
                                    {formatNumberLength(
                                        cabecera?.ubicacion_Viniedo_y
                                    )}
                                    , Longitud:{' '}
                                    {formatNumberLength(
                                        cabecera?.ubicacion_Viniedo_x
                                    )}
                                </td>
                                <td>DEPARTAMENTO DEL VIÑEDO: </td>
                                <td>{cabecera?.departamento_Viniedo}</td>
                            </tr>
                            <tr>
                                <td>DEPARTAMENTO DESTINATARIO: </td>
                                <td>
                                    {
                                        masters?.Departments?.find(
                                            (d) =>
                                                d.id ===
                                                cabecera?.departamento_Destinatario
                                        )?.nombre
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section className="guia_print-production-section">
                    <h3>UVA ENVIADA</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Variedad</th>
                                <th>Kilos Ingresados</th>
                                <th>Precio Kg</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itemsProductor?.map((it, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {
                                                grapesVariety?.find(
                                                    (gv) =>
                                                        gv.codigo ===
                                                        it.variedad
                                                )?.variedad
                                            }
                                        </td>
                                        <td>{it.kilos} kg</td>
                                        <td>${it.precio_Kg}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <footer className="guia_print-footer">
                    <label className="guia_print-label">
                        <span>TOTAL KILOS ENVIADOS: </span>
                        <p>{cabecera?.total_Kilos} kg</p>
                    </label>
                    <label className="guia_print-label">
                        <span>FECHA DE ENVÍO: </span>
                        <p>
                            {dayjs(cabecera?.fecha_Envio).format('DD-MM-YYYY')}
                        </p>
                    </label>
                    <label className="guia_print-label">
                        <span>FIRMA DEL VITICULTOR: </span>
                        <p>{cabecera?.firma_Viticultor}</p>
                    </label>
                </footer>
                <section className="guia_print-production-section">
                    <h3>UVA RECIBIDA</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Variedad</th>
                                <th>Kilos Ingresados</th>
                                <th>Grado de Glucosa</th>
                                <th>Precio Kg</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itemsBodega?.map((it, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {
                                                grapesVariety?.find(
                                                    (gv) =>
                                                        gv.codigo ===
                                                        it.variedad
                                                )?.variedad
                                            }
                                        </td>
                                        <td>
                                            {cabecera?.estado &&
                                            cabecera?.estado !== 1
                                                ? `${it.kilos} Kg`
                                                : ''}
                                        </td>
                                        <td>
                                            {cabecera?.estado &&
                                            cabecera?.estado !== 1
                                                ? it.grado_Gluc
                                                : ''}
                                        </td>
                                        <td>
                                            {cabecera?.estado &&
                                            cabecera?.estado !== 1
                                                ? `$${it.precio_Kg}`
                                                : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <footer className="guia_print-footer">
                    <label className="guia_print-label">
                        <span>TOTAL KILOS RECIBIDOS: </span>
                        <p>{cabecera?.total_Kilos} kg</p>
                    </label>
                    <label className="guia_print-label">
                        <span>FECHA DE RECEPCIÓN: </span>
                        <p>
                            {cabecera?.estado
                                ? cabecera?.fecha_Recepcion
                                    ? dayjs(cabecera?.fecha_Recepcion).format(
                                          'DD-MM-YYYY'
                                      )
                                    : ''
                                : ''}
                        </p>
                    </label>
                    <label className="guia_print-label">
                        <span>FIRMA DEL DESTINATARIO: </span>
                        <p>
                            {cabecera?.estado
                                ? cabecera?.firma_Destinatario
                                : ''}
                        </p>
                    </label>
                </footer>
            </div>
        </div>
    );
}

export default GuiaPrint;
